import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
    projectId: 'm7nsbw2x',
    dataset: 'production',
    apiVersion: '2021-08-31',
    useCdn: true,
    token: process.env.SANITY_TOKEN,


})

const builder = imageUrlBuilder(client);

export const urlFor = (source) => {
    return builder.image(source);
}   
